import React from "react";
import { NewsLetterProps } from "./props";
import classNames from "classnames";

export const Newsletter = ({ field, value, handleChange, fieldId }: NewsLetterProps): JSX.Element => {
  const { type, name, placeholder, isRequired, cssClass } = field;
  return (
    <div
      className={classNames({
        [cssClass]: cssClass,
        required: isRequired,
      })}
    >
      <div className="checkboxes">
        <label htmlFor={fieldId} className="checkbox">
          <input
            name={name}
            id={fieldId}
            checked={value[name] ? true : false}
            type="checkbox"
            onChange={handleChange}
            value="yes"
          />
          {placeholder}
        </label>
      </div>
    </div>
  );
};
